import PhotoSwipe from "photoswipe";
import Plyr from "plyr";

document.addEventListener("DOMContentLoaded", () => {
  const mvvSection = document.getElementById("home-mvv-section");
  if (!mvvSection) {
    return;
  }

  const tabButtons = mvvSection.querySelectorAll(".home-mvv__tab-button");
  const tabPanels = mvvSection.querySelectorAll(".home-mvv__tab-panel");
  const tabImage = document.getElementById("mvv-tab-image");

  if (!tabImage || tabButtons.length === 0 || tabPanels.length === 0) {
    return;
  }

  // --- TAB SWITCHING LOGIC (Existing) ---
  function activateTab(targetTabId, newImageSrc, newImageAlt) {
    tabButtons.forEach((button) => {
      button.classList.toggle(
        "active",
        button.dataset.tabTarget === targetTabId
      );
    });

    tabPanels.forEach((panel) => {
      panel.classList.toggle("active", panel.id === targetTabId);
    });

    if (tabImage.src !== newImageSrc) {
      tabImage.style.opacity = 0;
      setTimeout(() => {
        tabImage.src = newImageSrc;
        tabImage.alt = newImageAlt;
        tabImage.style.opacity = 1;
      }, 300);
    }
  }

  tabButtons.forEach((button) => {
    button.addEventListener("click", () => {
      const targetTabId = button.dataset.tabTarget;
      const newImageSrc = button.dataset.imageSrc;
      const newImageAlt = button.dataset.imageAlt;
      activateTab(targetTabId, newImageSrc, newImageAlt);
    });
  });

  // --- VIDEO LIGHTBOX LOGIC (Updated and Corrected) ---

  /**
   * Generates the correct embed URL for YouTube or Vimeo.
   * @param {string} originalUrl - The original video URL from the button.
   * @returns {string|null} The embeddable URL or null if invalid.
   */
  const generateEmbedUrl = (originalUrl) => {
    const siteOrigin = window.location.origin;
    let videoId;
    let embedUrl = null;

    // YouTube URL patterns
    const youtubeRegex =
      /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/ ]{11})/;
    const youtubeMatch = originalUrl.match(youtubeRegex);

    if (youtubeMatch && youtubeMatch[1]) {
      videoId = youtubeMatch[1];
      embedUrl = `https://www.youtube.com/embed/${videoId}?origin=${siteOrigin}&iv_load_policy=3&modestbranding=1&playsinline=1&showinfo=0&rel=0&enablejsapi=1&autoplay=1`;
    }

    // Vimeo URL patterns
    const vimeoRegex = /(?:vimeo\.com\/|player\.vimeo\.com\/video\/)([0-9]+)/;
    const vimeoMatch = originalUrl.match(vimeoRegex);

    if (vimeoMatch && vimeoMatch[1]) {
      videoId = vimeoMatch[1];
      embedUrl = `https://player.vimeo.com/video/${videoId}?origin=${siteOrigin}&autoplay=1`;
    }

    return embedUrl;
  };

  let activePlyrInstance = null;

  const destroyActivePlayer = () => {
    if (activePlyrInstance) {
      try {
        activePlyrInstance.destroy();
        activePlyrInstance = null;
      } catch (e) {
        console.error("Error destroying Plyr instance:", e);
      }
    }
  };

  mvvSection.addEventListener("click", (e) => {
    const trigger = e.target.closest(".js-mvv-video-trigger");
    if (!trigger) return;

    e.preventDefault();
    const originalVideoUrl = trigger.dataset.videoUrl;
    if (!originalVideoUrl) return;

    // Generate the correct embed URL
    const embedUrl = generateEmbedUrl(originalVideoUrl);
    if (!embedUrl) {
      console.error("Invalid video URL provided:", originalVideoUrl);
      return;
    }

    const dataSource = [
      {
        html: `<div class="pswp__video-container"><div class="plyr__video-embed js-plyr-player"><iframe src="${embedUrl}" allowfullscreen allowtransparency allow="autoplay"></iframe></div></div>`,
        type: "video",
      },
    ];

    const pswp = new PhotoSwipe({
      dataSource: dataSource,
      pswpModule: PhotoSwipe,
    });

    pswp.on("change", () => {
      destroyActivePlayer();
      const currentSlide = pswp.currSlide;
      if (currentSlide.data.type === "video") {
        const playerWrapper =
          currentSlide.content.element.querySelector(".js-plyr-player");
        if (playerWrapper) {
          activePlyrInstance = new Plyr(playerWrapper);

          activePlyrInstance.on("ready", (event) => {
            const controls = event.detail.plyr.elements.controls;
            if (controls) {
              controls.addEventListener("pointerdown", (e) => {
                e.stopPropagation();
              });
            }
          });

          // Autoplay is now handled by URL parameter for reliability
        }
      }
    });

    pswp.on("close", () => {
      destroyActivePlayer();
    });

    pswp.init();
  });
});
